import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { getDataSourceLogo } from '@atlassian/third-party-connector-configuration/connector-display-utils';
import type { ThirdPartyConnectorType } from '@atlassian/third-party-connector-configuration/connector-display-utils';

import type { RecommendedConnector } from '../connector-promo-config-types.ts';

export interface ConnectorIconPlaceholderProps {
	connector: RecommendedConnector;
	size?: 16 | 20 | 24;
}

const styles = cssMap({
	base: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: token('radius.xsmall'),
		backgroundColor: token('color.background.neutral'),
	},
	16: {
		width: '16px',
		height: '16px',
	},
	20: {
		width: '20px',
		height: '20px',
	},
	24: {
		width: '24px',
		height: '24px',
	},
});

export const ConnectorIconPlaceholder = ({
	connector,
	size = 24,
}: ConnectorIconPlaceholderProps) => {
	const { key, displayName } = connector;
	const LogoComponent = getDataSourceLogo(key as ThirdPartyConnectorType);

	if (LogoComponent) {
		return (
			<Box xcss={cx(styles.base, styles[size])} role="img" aria-label={displayName}>
				<LogoComponent size={size} />
			</Box>
		);
	}

	return (
		<Box xcss={cx(styles.base, styles[size])} role="img" aria-label={displayName}>
			<Text size="small" weight="semibold" color="color.text.subtle">
				{displayName.charAt(0).toUpperCase()}
			</Text>
		</Box>
	);
};
